import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { computed, inject, Injectable, signal } from '@angular/core';
import { environment } from '../../environments/environment';
import { CvatTasks } from '../models/tasks_cvat';
import { BehaviorSubject, catchError, forkJoin, from, map, Observable, of, Subject, switchMap, tap, throwError } from 'rxjs';
import { Firestore, collection, collectionData, query, where } from '@angular/fire/firestore';
import { FirebaseApp } from '@angular/fire/app';
import { Auth } from '@angular/fire/auth';


type PreMarkingData = {
  project_id: number;
  task_id: number;
  state: string;
  process_id?: string;
  // ...otros campos que tengas
};
@Injectable({
  providedIn: 'root'
})
export class CvatTasksService {
  private baseUrl: string = `${environment['api_backend']}/api`
  // TOKEN PARA API RECOGNITION
  private headers = new HttpHeaders({
    'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnRfdWlkIjoiY2IxNDk2Y2QtOTJhZi00YjE0LWFiZWItMjMwZWUzZGU5ZjA4IiwiY2xpZW50X2lkIjo0LCJpYXQiOjE3MjI0ODIzOTIsImV4cCI6MTcyMjQ5MzE5Mn0.6VEgFrRSx9uHEGWpAMhJViRzxwnOc7EyamkgrhnEojw`,
    'Accept': 'application/json'
  });
  private TasksSignal = signal<CvatTasks[]>([]);
  tasks = computed(() => this.TasksSignal());
  tasks$ = new BehaviorSubject<CvatTasks[]>(this.TasksSignal());

  firestore: Firestore = inject(Firestore);
  auth = inject(Auth)
  http = inject(HttpClient);


  private handleError(error: any): Observable<never> {
    console.error('An error occurred:', error);
    return throwError(error);
  }

  constructor() {

  };

  loadTasks(): void {
    let params = new HttpParams().set('limit', '200');
    this.http.get<CvatTasks[]>(`${this.baseUrl}/cvat/tasks`, { params }).subscribe({
      next: (tasks: CvatTasks[]) => {
        this.TasksSignal.set(tasks);
        this.tasks$.next(tasks);
      },
      error: (error) => this.handleError(error),
    });
  }
  getTasksDetails(task_id: number): Observable<CvatTasks> {
    return this.http.get<CvatTasks>(`${this.baseUrl}/cvat/tasks/${task_id}`).pipe(
      catchError(this.handleError)
    );
  }

  getJobsByTaskId(task_id: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/cvat/tasks/${task_id}/jobs`).pipe(
      map(response => response.results),
      catchError(this.handleError)
    );
  }
  
  loadTasksLazy(projectId: number, query: any): Observable<{ results: CvatTasks[], count: number }> {
  let params = new HttpParams()
    .set('page', query.page)
    .set('page_size', query.page_size);

  if (query.search) {
    params = params.set('search', query.search);
  }

  return this.http.get<{ results: CvatTasks[], count: number }>(`${this.baseUrl}/cvat-projects/${projectId}/tasks`, { params });
}


  getStates$(project_id: number): Observable<any[]> {
    const statesRef = collection(this.firestore, 'pre-marking');
    const q = query(statesRef, where('project_id', '==', Number(project_id)));
    return collectionData(q, { idField: 'id' })
  }

  retryProcess(event_id: string) {
    console.log('proceso', event_id)
    return this.http.post(`${this.baseUrl}/annotations/retry-process`, { event_id }).pipe(catchError(this.handleError));
  }

  deleteTask(task_id: number) {
    return this.http.delete(`${this.baseUrl}/cvat/tasks/${task_id}`).pipe(catchError(this.handleError));;
  }


  urlBucket(path: string, bucketName: string): Observable<string[]> {
    return this.http.post<{ urls: string[] }>(`${this.baseUrl}/gcs/list-url`, {
      folder: path,
      bucketName: bucketName
    }).pipe(
      map(res => res.urls || [])
    )
  }

}
